module.exports = __webpack_public_path__ + "img/2.e38fb1b3.png";